/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Tc_Offset_LabelInputs */

const en_transcript_export_tc_offset_label = /** @type {(inputs: Transcript_Export_Tc_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC Offset`)
};

const fr_transcript_export_tc_offset_label = /** @type {(inputs: Transcript_Export_Tc_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decalage TC`)
};

const de_transcript_export_tc_offset_label = /** @type {(inputs: Transcript_Export_Tc_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC Offset`)
};

const it_transcript_export_tc_offset_label = /** @type {(inputs: Transcript_Export_Tc_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset TC`)
};

const ru_transcript_export_tc_offset_label = /** @type {(inputs: Transcript_Export_Tc_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смещение TC`)
};

const es_transcript_export_tc_offset_label = /** @type {(inputs: Transcript_Export_Tc_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazamiento de TC`)
};

const zh_cn2_transcript_export_tc_offset_label = /** @type {(inputs: Transcript_Export_Tc_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC偏移`)
};

const ja_transcript_export_tc_offset_label = /** @type {(inputs: Transcript_Export_Tc_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TCオフセット`)
};

const hi_transcript_export_tc_offset_label = /** @type {(inputs: Transcript_Export_Tc_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीसी ऑफसेट`)
};

const pt_pt2_transcript_export_tc_offset_label = /** @type {(inputs: Transcript_Export_Tc_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deslocamento TC`)
};

/**
* | output |
* | --- |
* | "TC Offset" |
*
* @param {Transcript_Export_Tc_Offset_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_tc_offset_label = /** @type {((inputs?: Transcript_Export_Tc_Offset_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Tc_Offset_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_tc_offset_label(inputs)
	if (locale === "de") return de_transcript_export_tc_offset_label(inputs)
	if (locale === "it") return it_transcript_export_tc_offset_label(inputs)
	if (locale === "ru") return ru_transcript_export_tc_offset_label(inputs)
	if (locale === "es") return es_transcript_export_tc_offset_label(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_tc_offset_label(inputs)
	if (locale === "ja") return ja_transcript_export_tc_offset_label(inputs)
	if (locale === "hi") return hi_transcript_export_tc_offset_label(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_tc_offset_label(inputs)
	return en_transcript_export_tc_offset_label(inputs)
});